// extracted by mini-css-extract-plugin
module.exports = {"wrap":"list_wrap__1ofc_","sectionTit":"list_sectionTit__3LG_S","footer":"list_footer__S9570","tabs":"list_tabs__UVotr"};